import { computed, resolveDirective, createElementBlock, openBlock, createBlock, resolveDynamicComponent, mergeProps, withCtx, withDirectives, createElementVNode, createCommentVNode, toDisplayString, unref, createVNode } from "vue";
import DtIconLock from "@dialpad/dialtone-icons/vue3/lock";
import { DtBadge } from "@dialpad/dialtone-vue";
import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { serializeControlValue, deserializeControlValue } from "../../lib/control.js";
const _hoisted_1 = {
  class: "d-tt-capitalize",
  "data-qa": "dtc-option-bar-control-label"
};
const _hoisted_2 = {
  key: 1,
  class: "d-pl2 d-ps-relative d-b2"
};
const _hoisted_3 = {
  key: 2,
  class: "d-pl2 d-ps-relative d-b2"
};
const __default__ = {
  name: "DtcOptionBarControl"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    /**
     * Data of an entry in the 'control map'.
     */
    controlData: {
      type: Object,
      required: true
    },
    /**
     * Array of valid controls that are keys in the 'control map'.
     */
    validControls: {
      type: Array,
      required: true
    },
    /**
     * The member value.
     */
    value: {
      type: void 0,
      required: true
    },
    /**
     * The member label.
     */
    label: {
      type: String,
      required: true
    },
    /**
     * The member description.
     */
    description: {
      type: String,
      default: void 0
    },
    /**
     * If the member is a part of the v-model.
     */
    vModel: {
      type: Boolean,
      default: false
    },
    /**
     * If the member is considered required.
     */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * Prevent the control from being modified.
     */
    locked: {
      type: Boolean,
      default: false
    },
    /**
     * Optional args to bind directly to the control.
     */
    args: {
      type: Object,
      default: () => {
      }
    }
  },
  emits: [VALUE_UPDATE_EVENT],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const controlValue = computed(() => {
      return props.controlData.serialize ? serializeControlValue(props.value) : props.value;
    });
    const controlLabel = computed(() => props.label.replaceAll("-", " "));
    const controlComponent = computed(() => {
      return props.controlData.component;
    });
    const controlArgs = computed(() => {
      return {
        value: controlValue.value,
        disabled: props.locked,
        tags: props.tags,
        ...props.args
      };
    });
    const controlBindings = computed(() => {
      const component = controlComponent.value;
      if (!component.props) {
        return null;
      }
      return Object.fromEntries(
        Object.entries(controlArgs.value).filter(([arg]) => {
          const controlProps = Object.keys(component.props);
          return controlProps.includes(arg);
        })
      );
    });
    function updateValue(e) {
      const value = props.controlData.serialize ? deserializeControlValue(e) : e;
      emit(VALUE_UPDATE_EVENT, value);
    }
    return (_ctx, _cache) => {
      const _directive_dt_tooltip = resolveDirective("dt-tooltip");
      return openBlock(), createElementBlock("div", null, [
        (openBlock(), createBlock(resolveDynamicComponent(controlComponent.value), mergeProps(controlBindings.value, { "onUpdate:value": updateValue }), {
          default: withCtx(() => [
            withDirectives((openBlock(), createElementBlock("span", null, [
              createElementVNode("span", _hoisted_1, toDisplayString(controlLabel.value), 1),
              __props.locked ? (openBlock(), createBlock(unref(DtIconLock), {
                key: 0,
                class: "d-pr4 d-fs10 d-ps-relative d-t1"
              })) : createCommentVNode("", true),
              __props.required ? (openBlock(), createElementBlock("span", _hoisted_2, [
                createVNode(unref(DtBadge), {
                  text: "required",
                  color: "black-700"
                })
              ])) : createCommentVNode("", true),
              __props.vModel ? (openBlock(), createElementBlock("span", _hoisted_3, [
                createVNode(unref(DtBadge), {
                  text: "v-model",
                  color: "black-700"
                })
              ])) : createCommentVNode("", true)
            ])), [
              [_directive_dt_tooltip, __props.description]
            ])
          ]),
          _: 1
        }, 16))
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=option_bar_control.vue.js.map
